// generated from 638 samples

import { z } from "zod";
import { common } from "../common";
import { stepGetBaseSchema } from "./stepGetBaseSchema";

export const googleAudienceSyncStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("GOOGLE_AUDIENCE_SYNC"),
  step_data: z.object({
    action: z.enum([
      "add_users", // 534 (83.70%)
      "remove_users", // 104 (16.30%)
    ]),
    // null: 39 (6.11%)
    // format integer: 594 (99.17%)
    ad_account_id: z.string().nullable(),
    app_group_id: common.objectId,
    // true 1 (0.16%), false 637 (99.84%)
    bulk_flusher_rate_limit_violation: z.boolean(),
    canvas_id: common.objectId,
    // null: 82 (12.85%)
    custom_audience_id: z.string().nullable(),
    // null: 19 (2.98%)
    custom_audience_name: z.string().nullable(),
    fields_to_match: z.array(z.string()),
    // null: 14 (2.19%)
    intent: z
      .enum([
        "sync_to_existing", // 533 (85.42%)
        "create_new", // 91 (14.58%)
      ])
      .nullable(),
  }),
});
